import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { I18nInterpolateDirective } from '../i18n/components/i18n-interpolate.directive';
import { I18nComponent } from '../i18n/components/i18n.component';
import { useI18n } from '../i18n/services/i18n.service';
import { BackButtonComponent } from '../navigation/components/back-button/back-button.component';
import { WebComponentDirective } from '../web-component/web-component.directive';

@Component({
  selector: 'cdf-hello',
  imports: [I18nComponent, I18nInterpolateDirective, BackButtonComponent],
  template: `
    <p>
      <cdf-back-button />
      @if (name()) {
        <i18n key="hello">
          <span class="mask" *i18nInterpolate="'name'">{{ name() }}</span>
        </i18n>
      } @else {
        {{ i18n('helloWorld') }}
      }
    </p>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelloPage extends WebComponentDirective {
  protected readonly i18n = useI18n();

  readonly name = input<string>();
}
